import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import "./RookiePacketTable.scss";

const RookiePacketTable = ({
  packets = [],
  handlePacketSelect,
  selectedPacket = null,
  level = "intermediate",
}) => {
  return (
    <TableContainer className={`packet-table-rookie ${level}`}>
      <Table size="small" stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell>No.</TableCell>
            <TableCell>Time</TableCell>
            <TableCell>Scr</TableCell>
            <TableCell>Dst</TableCell>
            <TableCell>Proto</TableCell>
            <TableCell>Length</TableCell>
            <TableCell>Data</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {packets.map((packet, index) => (
            <TableRow
              key={index}
              onClick={() => handlePacketSelect(packet.no)}
              className={selectedPacket?.no === packet.no ? "active-row" : ""}
            >
              <TableCell>{index + 1}</TableCell>
              <TableCell>{packet.time}</TableCell>
              <TableCell>{packet.src}</TableCell>
              <TableCell>{packet.dst}</TableCell>
              <TableCell>{packet.proto}</TableCell>
              <TableCell>{packet.length}</TableCell>
              <TableCell>
                {/* <Tooltip title={packet.data.toString()} arrow> */}
                {packet.data.toString().slice(0, 15)}...
                {/* </Tooltip> */}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default RookiePacketTable;
